export default __webpack_public_path__ + "static/media/Lærervejledning.6ae28d50.pdf";